var _path, _path2, _circle, _path3, _rect, _path4, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraderslist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 13.3926L27.0313 15.3926",
    stroke: "#A4A8AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5833 12L17 16.6666",
    stroke: "#A4A8AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2459,
    cy: 18.6385,
    r: 2.4959,
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4685 31.0782L28.1726 26.0259C28.3769 24.5599 27.5144 23.1546 26.1148 22.6732L26.0243 22.642C25.1061 22.3262 24.091 22.4883 23.3169 23.0745V23.0745C22.4695 23.7162 21.2907 23.6998 20.4574 23.0399V23.0399C19.7004 22.4403 18.6928 22.2489 17.77 22.5333L17.7097 22.5518C16.2235 23.0098 15.3194 24.5122 15.6108 26.0399L16.5717 31.0777",
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 30.7979,
    width: 18,
    height: 3,
    rx: 1.5,
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7736 30.9285V26.4195C25.7736 26.0044 25.4371 25.668 25.0221 25.668H18.6343C18.2193 25.668 17.8828 26.0044 17.8828 26.4195V30.9285",
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.53,
    cy: 17.7556,
    r: 1.53,
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.03,
    cy: 11.7321,
    r: 1.52998,
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5612,
    cy: 16.9226,
    r: 1.52998,
    stroke: "#A4A8AE",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraderslist);
export default __webpack_public_path__ + "static/media/traderslist.7d001c9e773557f7cde18a7700dad4ec.svg";
export { ForwardRef as ReactComponent };